import { FetchTenderByIdDocument, FetchTenderByIdQuery, FetchTenderByIdQueryVariables } from "@/graphql/__generated__/graphql";
import { useQuery } from "@apollo/client/react";

export const useFetchTenderByIdQueryHook = (currentTenderID: number) => {
  const { data: tenderByIdData, loading, refetch: tenderByIdRefetch } = useQuery<FetchTenderByIdQuery, FetchTenderByIdQueryVariables>(
    FetchTenderByIdDocument, {
      variables: {
        id: Number(currentTenderID)
      }
    });

  // Only show loading on initial load, not on refetches or cache updates
  // If we already have data, don't show loader even if loading is true
  const tenderByIdLoading = loading && !tenderByIdData;

  return {
    tenderByIdData,
    tenderByIdLoading,
    tenderByIdRefetch
  };
};
